import React, {useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import {UserInterface} from "../model/UserInterface";
import axios from "axios";
import {Link} from "react-router-dom";
import { handleError } from "../error/ErrorHandler";

const JoinInput = (props: any) => {
    const [visibleStyle, setVisibleStyle] = useState('false')
    const [usrEmlExtension, setUsrEmlExtension] = useState("")
    const [selectOptionVisible, setSelectOptionVisible] = useState("show")
    const [isDuplicateNameChecked, setIsDuplicateNameChecked] = useState(false)
    const [isApproveEmail, setIsApproveEmail] = useState(false);
    const [isSendEmail, setIsSendEmail] = useState(false);

    let [currentUserId, setCurrentId] = useState("")
    let [currentUserPw, setCurrentUserPw] = useState("")
    let [currentUserTel, setCurrentUserTel] = useState("")

    const [smsYnMsg, setSmsYnMsg] = useState('')
    const [smsYnMsgClassName, setSmsYnMsgClassName] = useState('error-msg')
    let [pwMatchMsg, setPwMatchMsg] = useState("");
    let [pwMatchClassName, setPwMatchClassName] = useState("error-msg");
    const { register, handleSubmit, getValues, formState: { errors } } = useForm();

    const [termYn] = useState("N");
    const [privacyYn] = useState("N");

    const [encData, setEncData] = useState("");

    useEffect(() => {
        if(props.firstStepVisibleYn === 'false') setVisibleStyle('true')
        if(props.secondStepVisibleYn === 'false') setVisibleStyle('false')

        window.addEventListener('message', (msg) => {
            if (msg.data === 'error') {
                setSmsYnMsg('휴대폰 본인인증에 실패했습니다.')
                setSmsYnMsgClassName('error-msg')
            }
            else {
                setCurrentUserTel(msg.data);
                setSmsYnMsg('휴대폰 본인인증에 성공했습니다.')
                setSmsYnMsgClassName('correct-msg')
            }
        });
    }, [visibleStyle, pwMatchMsg, usrEmlExtension, currentUserId, selectOptionVisible, props.firstStepVisibleYn, props.secondStepVisibleYn, encData ]);

    const usrEmlExt = (event: any) => {
        if (event.target.value === 'naver.com'|| event.target.value==='kakao.com' || event.target.value ==='hanmail.net') {
            setSelectOptionVisible('hide')
            setUsrEmlExtension(event.target.value);
        } else {
            setSelectOptionVisible('show');
            setUsrEmlExtension(event.target.value);
        }
    }

    const checkIdDuplicated = async() => {
        try {
            const res = await axios.get('/api/user/validation/id/' + currentUserId);
            if (res.data) {
                alert('중복아이디 입니다.')
                setIsDuplicateNameChecked(false)
            }
            else {
                alert('사용가능한 아이디 입니다.')
                setIsDuplicateNameChecked(true)
            }
        } catch(err) {
            handleError(err);
        }
    }

    const getCurrentUserId = (event: any) => {
        setCurrentId(event.target.value);
    }

    const setCurrentPw = (event: any) => {
        setCurrentUserPw(event.target.value);
    }

    const isPasswordMatches = (event: any) => {
        let userPwAgain = event.target.value;
        if (currentUserPw === userPwAgain) {
            setPwMatchMsg("비밀번호가 일치합니다")
            setPwMatchClassName('correct-msg')
        }
        else if (userPwAgain === null || userPwAgain == '') {
            setPwMatchMsg("")
            setPwMatchClassName('error-msg')
        }
        else {
            setPwMatchMsg('비밀번호가 일치하지 않습니다.')
            setPwMatchClassName('error-msg')
        }
    }

    const onSubmit = (data: any) => {
        if (!isDuplicateNameChecked) {
            alert('아이디 중복체크를 해주세요.')
        } else if (pwMatchClassName === 'error-msg') {
            alert('비밀번호를 확인해주세요.')
        } else if (props.isRequireTel && (currentUserTel == null || currentUserTel == '')) {
            alert('본인인증을 완료해주세요.')
        } else if (!isApproveEmail) {
            alert('이메일인증을 완료해주세요.');
        } else {
            data.usrEml = data.usrEml?.concat('@').concat(usrEmlExtension)
            data.usrTel = currentUserTel;
            insertData(data);
        }
    };

    const insertData = async (data: UserInterface | undefined) => {
        if (data) {
            data["trmUseYn"] = termYn;
            data["prvPlcYn"] = privacyYn;
            data["usrAuth"] = 'N';
        }
        try {
            const res = await axios.post('/api/user', data);
            props.childInsertData(data)
            setVisibleStyle('false')
            props.secondStepVisibleStyle('false')
        } catch(err: any) {
            console.log(err.response)
            alert('회원가입에 실패했습니다.')
        }
    }

    const nicePhonePopup = async () => {
        try {
            const res = await axios.get('/api/user/check/nice/enc-data');
            setEncData(res.data);
            checkTelNoByNiceModule();
        } catch(err) {
            handleError(err);
        }
    }

    const checkTelNoByNiceModule = async () => {
        window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
        document.forms[0].action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
        document.forms[0].submit();
    }

    const sendMail = async () => {
        try {
            const usrEml = getValues("usrEml");
            if(!usrEml || !usrEmlExtension) return alert('이메일을 입력해주세요.');

            const mail = usrEml?.concat('@').concat(usrEmlExtension);

            //너무 오래걸려서 일단 전송했다고 알림
            setIsSendEmail(true);
            alert('메일로 인증번호를 전송하였습니다.');
            const res = await axios.post('/api/mail/send/verification-code', { receivers: [ mail ]});
            if (res.status !== 200) throw new Error();
        } catch(err) {
            alert('메일 전송에 실패했습니다.');
        }
    }

    const checkVerificationCode = async () => {
        const verificationCode = getValues("verificationCode");
        if (!verificationCode) return alert('인증번호를 입력해주세요.');
        try {
            const res = await axios.post('/api/mail/check/verification-code', { verificationCode });
            if (res.status !== 200) throw new Error();
            setIsApproveEmail(true);
            alert('인증에 성공했습니다.');
        } catch(err) {
            alert('인증에 실패했습니다.');
        }
    }

    return (
        <div className={`join-input-wrapper ${visibleStyle==='true' ? 'show' : 'no-show'}`}>
            <form name={'form_chk'} method="post" target={'popupChk'}>
                <input type="hidden" name="m" value="checkplusService" />
                <input type="hidden" name="EncodeData" value={encData}/>
            </form>
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className={'join-input-content'}>
                <div className={'join-input-header-wrapper flex-space-between'}>
                    <span className={'join-input-header-title'}>회원정보</span>
                    <span className={'join-input-header-alert'}>* 필수사항입니다.</span>
                </div>
                <div className={'join-input-form-wrapper'}>
                    <div className={'join-input-form-content'}>
                        <div className={'join-input-form-item'}>
                            <label>
                                <span className={'join-input-form-item-label'}>
                                    이름
                                    <span>*</span>
                                </span>
                                <input type={'text'} className={'join-input-text'} {...register("usrNm", {
                                    required: "필수 입력값입니다.",
                                    maxLength: {
                                        value: 20,
                                        message: "최대 20자리까지 입력가능합니다."
                                    }
                                })} />
                                {errors.usrNm && <span className={'error-msg'}>{errors.usrNm.message}</span>}

                            </label>
                        </div>
                        <div className={'join-input-form-item'}>
                            <label>
                                <span className={'join-input-form-item-label'}>
                                    아이디
                                    <span>*</span>
                                </span>
                                <input type={'text'} className={'join-input-text'} {...register("usrId", {
                                    required: "필수 입력값입니다.",
                                    maxLength: {
                                        value: 15,
                                        message: "최대 15자리까지 사용 가능합니다."
                                    }
                                })}  onChange={getCurrentUserId}/>
                                {errors.usrId && <span className={'error-msg'}>{errors.usrId.message}</span>}

                                <button type="button" className={'join-agree-button'} onClick={checkIdDuplicated}>중복확인</button>
                            </label>
                        </div>
                        <div className={'join-input-form-item'}>
                            <label>
                                <span className={'join-input-form-item-label'}>
                                    비밀번호
                                    <span>*</span>
                                </span>
                                <input type={'password'} className={'join-input-text md'} {...register("usrPw", {
                                    required: "필수 입력값입니다.",
                                    minLength: {
                                        value: 8,
                                        message: "최소 8자리 이상 입력해주세요."
                                    },maxLength: {
                                        value: 30,
                                        message: "최대 30자리 이하 입력해주세요."
                                    },
                                })} onChange={setCurrentPw}/>
                                {errors.usrPw && <span className={'error-msg'}>{errors.usrPw.message}</span>}
                                <span className={'join-input-form-item-desc m-10'}>
                                    8-30자의 영문 소문자, 숫자를 조합하여 입력해주세요.
                                </span>
                            </label>
                        </div>
                        <div className={'join-input-form-item'}>
                            <label>
                                <span className={'join-input-form-item-label'}>
                                    비밀번호 확인
                                    <span>*</span>
                                </span>
                                <input type={'password'} className={'join-input-text md'} onChange={isPasswordMatches}/>
                                <span className={pwMatchClassName}>{pwMatchMsg}</span>

                                {/*<span className={pwMatchMsg ? 'correct-msg ' : 'error-msg'}>{pwMatchMsg ? '비밀번호가 일치합니다' : '비밀번호가 일치하지 않습니다.'}</span>*/}
                            </label>
                        </div>
                        <div className={'join-input-form-item'}>
                            <label>
                                <span className={'join-input-form-item-label'}>
                                    소속기관
                                    <span>*</span>
                                </span>
                                <input type={'radio'} value={'N'} {...register("orgYn",{required: true})}/> 개인
                                <input type={'radio'} value={'Y'} {...register("orgYn", {required: true})}/> 컨소시움 참여 기관
                                {errors.orgYn && <span className={'error-msg'}>필수 선택값입니다.</span>}
                            </label>
                        </div>
                        <div className={'join-input-form-item'}>
                            <label>
                                <span className={'join-input-form-item-label'}>
                                    기관명
                                </span>
                                <input type={'text'} className={'join-input-text'} {...register("orgNm")}/>
                            </label>
                        </div>
                        <div className={'join-input-form-item'}>
                            <label>
                                <span className={'join-input-form-item-label'}>
                                    이메일
                                    <span>*</span>
                                </span>

                                <input type={'text'} className={'join-input-text md'}  {...register("usrEml", { required: true })} />
                                &nbsp;@&nbsp;
                                <input type={'text'} className={`join-input-text sm ${selectOptionVisible === 'show' ? '' : 'no-show'}`} onChange={usrEmlExt} />
                                <select className={'join-input-text sm'} style={{ marginLeft: '3px' }} onChange={usrEmlExt}>
                                    <option value={'self'}>직접입력</option>
                                    <option value={'naver.com'} id={'naver'}>naver.com</option>
                                    <option value={'kakao.com'} id={'kakao'}>kakao.com</option>
                                    <option value={'hanmail.net'} id={'hanmail'}>hanmail.net</option>
                                </select>
                                <button type="button" className={'join-agree-button'} onClick={sendMail}>메일인증</button>
                            </label>
                        </div>
                        { isSendEmail && 
                             <div className={'join-input-form-item'}>
                                <label>
                                    <span className={'join-input-form-item-label'}>
                                        이메일 인증
                                    </span>
    
                                    <input type={'text'} placeholder="인증번호" className={'join-input-text md'}  {...register("verificationCode")} />
                                    <button type="button" className={'join-agree-button'} onClick={checkVerificationCode}>확인</button>
                                </label>
                            </div>
                        }
                        
                        <div className={'join-input-form-item'}>
                            <label>
                                <span className={'join-input-form-item-label'}>
                                    메일 수신여부
                                    <span>*</span>
                                </span>
                                <input type={'radio'} value={'Y'}  {...register("emlYn", {required: true})}/> 예
                                <input type={'radio'} value={'N'} {...register("emlYn", {required: true})} /> 아니오
                                {errors.emlYn && <span className={'error-msg'}>필수 선택값입니다.</span>}
                            </label>
                        </div>
                        { props.isRequireTel && 
                            <>
                                <div className={'join-input-form-item'}>
                                    <label>
                                        <span className={'join-input-form-item-label'}>
                                            휴대폰 번호
                                            <span>*</span>
                                        </span>
                                        {/*<input type={'text'} className={'join-input-text md'} {...register("usrTel")} readOnly/>*/}
                                        {/*{errors.usrTel && <span className={'error-msg'}>필수 입력값입니다.</span>}*/}
                                        <button type="button" className={'join-agree-button'} onClick={nicePhonePopup}>본인인증</button>
                                        <span className={smsYnMsgClassName}>{smsYnMsg}</span>
                                    </label>
                                </div>
                                <div className={'join-input-form-item last'}>
                                    <label>
                                        <span className={'join-input-form-item-label'}>
                                            SMS 수신여부
                                            <span>*</span>
                                        </span>
                                        <input type={'radio'} value={'Y'} {...register("smsYn", {required: true})}/> 예
                                        <input type={'radio'} value={'N'} {...register("smsYn", {required: true})}/> 아니오
                                        {errors.smsYn && <span className={'error-msg'}>필수 선택값입니다.</span>}
                                    </label>
                                </div>
                            </>
                        }
                    </div>
                </div>
                <div className={'join-button-wrapper flex-center'}>
                    <div className={'join-button-content flex-space-between'}>
                        <Link to={'/'}><button className={'join-button cancel'}>취소</button></Link>
                        <button type="submit" className={'join-button confirm'}>확인</button>
                    </div>
                </div>
            </div>
            </form>
        </div>
    );
}

export default JoinInput;
